import { useTranslation } from 'react-i18next'
import { IEvaluationSection } from 'models/evaluation.model'
import { TableSkeleton } from 'components/reusables/skeletons'
import { useEvaluation } from '../contexts/Evaluation'
import { Section, SectionTitle, SectionDescription } from './styled'
import Questions from './questions'

export const Sections = () => {
  const { t } = useTranslation()

  const { isReviewing, isSectionsInReviewMode, sections } = useEvaluation()
  const loading = sections.isLoading

  const translationPrefix = 'lessons.contentBlocks.evaluation'

  const getScore = (section: IEvaluationSection) => {
    let totalScore = 0
    let obtainedScore = 0

    section.questions.forEach((question) => {
      totalScore += question.score
      if (question.userAnswer?.correct) obtainedScore += question.score
    })

    return t(`${translationPrefix}.score`, {
      obtainedScore: obtainedScore,
      totalScore: totalScore,
    })
  }

  return (
    <>
      {loading ? (
        <Section>
          <TableSkeleton />
        </Section>
      ) : (
        sections.data?.map((section, index) => (
          <Section key={index}>
            <SectionTitle>
              <div>{section.name}</div>
              {isSectionsInReviewMode && <span>{getScore(section)}</span>}
            </SectionTitle>
            {section.description && (
              <SectionDescription>{section.description}</SectionDescription>
            )}
            <Questions section={section} />
          </Section>
        ))
      )}
    </>
  )
}

export default Sections
